import gql from 'graphql-tag';
import ReportFragment from './reportFragment';

const reportsQuery = gql`
  query reports($input: ReportsQueryInput!) {
    reports(input: $input) {
      filter {
        group
        offset
        limit
      }
      hasNextPage
      reports {
        type
        ...ReportFragment
      }
    }
  }
  ${ReportFragment}
`;

export default reportsQuery;
